export default __webpack_public_path__ + "static/media/link-expired.ac92ee5b.svg";